import { render } from "./CardAddBudget.vue?vue&type=template&id=284f7046&scoped=true"
import script from "./CardAddBudget.vue?vue&type=script&lang=js"
export * from "./CardAddBudget.vue?vue&type=script&lang=js"

import "./CardAddBudget.vue?vue&type=style&index=0&id=284f7046&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284f7046"]])

export default __exports__